import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';
import { ClasePerdida } from '../models/clase-perdida';

@Component({
    selector: 'clase-perdida-list',
    standalone: false,
    templateUrl: 'clase-perdida-list.component.html',
    styleUrls: ['clase-perdida-list.component.scss']
})

export class ClasePerdidaListComponent {

    @Input() loading: boolean;
    @Input() errorMessage: string;
    @Input() perdidas: ClasePerdida[];
    @Input() materias: MateriaMin[];
    @Output() delete = new EventEmitter<ClasePerdida>();

    displayedColumns: string[] = ['fecha', 'materia', 'horas', 'motivo', 'accion'];

    getMateria(id: number, materias: MateriaMin[]) {
        return materias.find(e => e.id === id)?.nombre ?? '';
    }

    deleteClasePerdida(clasePerdida: ClasePerdida) {
        // FIXME: i18n mensaje borrar
        if (confirm(`¿Borrar el registro de ${this.getMateria(
                clasePerdida.materiaCursoPeriodoID
                , this.materias)} del ${formatDate(
                    clasePerdida.fecha, 'dd MMM yyyy', 'es_CO')}?`)) {
            let updatedclasePerdida = { ...clasePerdida };
            updatedclasePerdida.isActive = false;
            this.delete.emit(updatedclasePerdida);
        }
    }
}